import React, { useState } from 'react'
import { Button } from 'components/Button';
import { FormBoxHeading, FormBoxWrapper, FormRightBox, InputFieldStyle, FormSubmitBtn, NeedAnAccount, TermsandConditions } from '../FormsStyled';
import { FormErrorColor, MenuModelText } from '../ModalStyled';
import { useForm, SubmitHandler } from 'react-hook-form';
import FormImage from '../FormImageBox';
import { Link } from "react-router-dom"
import { Box } from 'components/Box';
import { ReactComponent as BackIcon } from 'assets/Icons/BackIcon.svg';
import axios from 'libs/axios';
import SignupModalDialog from './SignupModal';
import { toast } from 'react-toastify';

const Signup: React.FC = () => {

    type Inputs = {
        email: string,
        password: string,
        ConfirmPassword: string,
        TermsandConditions: string,
        referred_by: string,
    };

    const [open, setOpen] = useState(false);
    const { register, handleSubmit, getValues, formState: { errors } } = useForm<Inputs>();
    // const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState('');

    const onSubmit: SubmitHandler<Inputs> = async data => {
        try {
            setLoading(true);
            const result = await axios.post('/user/register', data);
            toast.success(result.data.message);
            setEmail(data.email);
            setOpen(true);
        } catch (err) {
            //@ts-ignore
            toast.error(err.response.data.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <FormBoxWrapper>

                <FormImage />

                <Box>
                    <Box display={['none', 'none', 'none', 'block']}>
                        <Link to="/">
                            <BackIcon />
                        </Link>
                    </Box>

                    <FormRightBox>
                        <FormBoxHeading>CREATE YOUR ACCOUNT</FormBoxHeading>

                        <form onSubmit={handleSubmit(onSubmit)}>

                            <InputFieldStyle>
                                <label>Email</label>
                                <input type="email" className="form-control" {...register("email", { required: { value: true, message: "Email is Required" }, pattern: { value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: "Invalid Email" } })} />
                                <FormErrorColor>{errors.email && errors.email.message}</FormErrorColor>
                            </InputFieldStyle>

                            <InputFieldStyle>
                                <label>Password</label>
                                <input type="password" className="form-control" {...register("password", { required: { value: true, message: "Password is Required" }, minLength: { value: 6, message: "Password must be greater than 6 Characters." }, })} />
                                <FormErrorColor>{errors.password && errors.password.message}</FormErrorColor>
                            </InputFieldStyle>

                            <InputFieldStyle>
                                <label>Confirm Password</label>
                                <input type="password" className="form-control" {...register("ConfirmPassword", {
                                    required: { value: true, message: "Confirm Password is Required" }, minLength: { value: 6, message: "Password must be greater than 6 characters" }, validate: {
                                        checkEq: val => val === getValues('password') || "Confirm Password should be Same."
                                    },
                                })} />
                                <FormErrorColor>{errors.ConfirmPassword && errors.ConfirmPassword.message}</FormErrorColor>
                            </InputFieldStyle>

                            <InputFieldStyle>
                                <label>Referred By ( Optional )</label>
                                <input type="text" className="form-control" {...register("referred_by")} />
                            </InputFieldStyle>

                            <TermsandConditions alignItems='center'>
                                <input type='checkbox' style={{ marginRight: '10px' }} {...register("TermsandConditions", { required: { value: true, message: "Field is Required. " }, })} /> I Agree to<Link to='/termsandservices'>Terms &amp; Conditions</Link>
                                <FormErrorColor>{errors.TermsandConditions && errors.TermsandConditions.message}</FormErrorColor>
                            </TermsandConditions>

                            <FormSubmitBtn>
                                <Button type="submit">SIGNUP</Button>
                            </FormSubmitBtn>

                            <NeedAnAccount alignItems='center'>
                                <MenuModelText> Already have an Account?</MenuModelText>
                                <Link to='/login'>Login</Link>
                            </NeedAnAccount>
                        </form>

                        <SignupModalDialog open={open} setOpen={setOpen} email={email} />

                    </FormRightBox>
                </Box>

            </FormBoxWrapper>

        </>
    )
}

export default Signup